/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

/**
 *
 *
 * 0 = ServiceOfferPlan
 *
 * 1 = NPS
 */
export enum TeamPerfomanceValueEnum {
  ServiceOfferPlan = 0,
  NPS = 1,
}
